import { debug, observer, React, RouteComponentProps } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { TradingPreferencesRoutes } from "./TradingPreferencesRoutes";
import { TradingPreferencesStore } from "./TradingPreferencesStore";
import { TradingPreferencesSummary } from "./TradingPreferencesSummary";


type IProps = RouteComponentProps<{}> & {
    store: TradingPreferencesStore;
};

@observer
export class TradingPreferencesSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store?.signInfo}
                content={<TradingPreferencesSummary store={this.props.store} />}
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(TradingPreferencesRoutes.SUCCESS);
                }}
                onRetry={async () => {
                    debug.log("### signing retry");
                    try {
                        this.props.store.postTradingPreferences();
                    } catch (error) {
                        pushRoute("/error");
                    }
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesSigning.tsx